"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var USE_COLOR_CHANGE_ID = '__use_color_change';
var insertStyleSheetRule = function (ruleText) {
    var style = document.getElementById(USE_COLOR_CHANGE_ID);
    if (style == null) {
        style = document.createElement('style');
        style.setAttribute('id', USE_COLOR_CHANGE_ID);
        style.appendChild(document.createTextNode(''));
        document.head.appendChild(style);
    }
    var sheet = style.sheet;
    sheet === null || sheet === void 0 ? void 0 : sheet.insertRule(ruleText, sheet.rules ? sheet.rules.length : sheet.cssRules.length);
};
var makeAnimation = function (color, property) {
    var random = 'use-color-change' + String(Math.random()).replace(/\./g, '');
    var animation = "@keyframes " + random + " { from {" + property + ": " + color + ";} to {} }";
    insertStyleSheetRule(animation);
    return random;
};
var useColorChange = function (value, options) {
    var _a = (0, react_1.useState)(value), val = _a[0], setVal = _a[1];
    var _b = (0, react_1.useState)(''), animation = _b[0], setAnimation = _b[1];
    var duration = options.duration || 1800;
    var property = options.property || 'color';
    (0, react_1.useEffect)(function () {
        if (value > val && options.higher) {
            setAnimation(makeAnimation(options.higher, property));
        }
        else if (value < val && options.lower) {
            setAnimation(makeAnimation(options.lower, property));
        }
        setVal(value);
    }, [duration, property, options.higher, options.lower, val, value]);
    if (!animation) {
        return {};
    }
    return {
        animation: animation + " " + duration / 1000 + "s"
    };
};
exports.default = useColorChange;
